import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedBranch: JSON.parse(localStorage.getItem('selectedBranch')) || null,
  loading: false,
  error: null
};

const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    setBranch: (state, action) => {
      state.selectedBranch = action.payload;
      localStorage.setItem('selectedBranch', JSON.stringify(action.payload));
    },
    clearBranch: (state) => {
      state.selectedBranch = null;
      localStorage.removeItem('selectedBranch');
    }
  }
});

export const { setBranch, clearBranch } = branchSlice.actions;
export default branchSlice.reducer;
